import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { Input, Message, Switch, Button } from "../../../BP2Components";
import "../GlobalSettings/GlobalSettings.less";

const BasketSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      ...value
   });
   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChange = (name) => (e) => {
      setSettings({ ...settings, [name]: e.target.value });
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="basketSettings" className="widget-settings__inner">
                  <label key="shopName" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.shopName" />:
                     <Input
                        type="text"
                        name="shopName"
                        onChange={handleChange("shopName")}
                        defaultValue={value.shopName}
                     />
                  </label>
                  <label key="listId" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.listId" />:
                     <Input
                        type="number"
                        name="listId"
                        onChange={handleChange("listId")}
                        defaultValue={value.listId}
                     />
                  </label>
                  <label key="orderWorkflowConfigId" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.orderWorkflowConfigId" />:
                     <Input
                        type="number"
                        name="orderWorkflowConfigId"
                        onChange={handleChange("orderWorkflowConfigId")}
                        defaultValue={value.orderWorkflowConfigId}
                     />
                  </label>
                  <label key="showPrice" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.showPrice" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showPrice")}
                        defaultChecked={value.showPrice}
                     />
                  </label>
                  <label key="showActions" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.showActions" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showActions")}
                        defaultChecked={value.showActions}
                     />
                  </label>
                  <label key="changeQuantity" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.changeQuantity" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "changeQuantity")}
                        defaultChecked={value.changeQuantity}
                     />
                  </label>

                  <label key="showAdditionalInfo" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.showAdditionalInfo" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showAdditionalInfo")}
                        defaultChecked={value.showAdditionalInfo}
                     />
                  </label>
                  <label key="showImage" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.showImage" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showImage")}
                        defaultChecked={value.showImage}
                     />
                  </label>
                  <label key="imageWidth" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.imageWidth" />:
                     <Input
                        type="number"
                        name="imageWidth"
                        onChange={handleChange("imageWidth")}
                        min={1}
                        defaultValue={value.imageWidth}
                     />
                  </label>
                  <label key="imageHeight" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.imageHeight" />:
                     <Input
                        type="number"
                        name="imageHeight"
                        onChange={handleChange("imageHeight")}
                        min={1}
                        defaultValue={value.imageHeight}
                     />
                  </label>
                  <label key="allowExceedUserBudget" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.allowExceedUserBudget" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "allowExceedUserBudget")}
                        defaultChecked={value.allowExceedUserBudget}
                     />
                  </label>
                  <label key="userBudgetIdColTechname" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.userBudgetIdColTechname" />:
                     <Input
                        type="text"
                        name="userBudgetIdColTechname"
                        onChange={handleChange("userBudgetIdColTechname")}
                        defaultValue={value.userBudgetIdColTechname}
                     />
                  </label>
                  <label key="allowExceedStoreLimit" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.allowExceedStoreLimit" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "allowExceedStoreLimit")}
                        defaultChecked={value.allowExceedStoreLimit}
                     />
                  </label>
                  <label key="currency" className="widget-settings__inner__label">
                     <IntlMessages id="shopping.basket.currency" />:
                     <Input
                        type="text"
                        name="currency"
                        onChange={handleChange("currency")}
                        defaultValue={value.currency}
                     />
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default BasketSettings;
